import { ExternalRoute } from "@/constants/externalRoute.ts"
import {
  ABOUT_US_NAVIGATION_ITEM,
  HELP_NAVIGATION_ITEM,
  PRODUCTS_NAVIGATION_ITEM,
} from "@/constants/navigation/navigation.ts"
import { NAV_LABELS } from "@/constants/navigation/navigationTypes.ts"
import { Route as InternalRoute } from "@/constants/route.ts"
import { NavbarItem } from "@/types/Navbar.ts"

const SIDEBAR: NavbarItem[] = [
  { to: InternalRoute.home, label: NAV_LABELS.accountHome },
  { to: InternalRoute.usage, label: NAV_LABELS.energyUsage },
  {
    to: ExternalRoute.meterReadings,
    label: NAV_LABELS.meterReadings,
  },
  {
    to: import.meta.env.VITE_USE_NEXUS_TARIFF_PAGE
      ? InternalRoute.tariff
      : ExternalRoute.tariff,
    label: NAV_LABELS.tariff,
  },
  { to: ExternalRoute.movingHome, label: NAV_LABELS.movingHome },
] as const

const TOP: NavbarItem[] = [
  {
    label: NAV_LABELS.account,
    children: SIDEBAR,
  },
  ABOUT_US_NAVIGATION_ITEM,
  HELP_NAVIGATION_ITEM,
  PRODUCTS_NAVIGATION_ITEM,
] as const

const TABLET: NavbarItem[] = [
  {
    label: NAV_LABELS.menu,
    children: TOP,
  },
] as const

const MOBILE: NavbarItem[] = [
  ...SIDEBAR,
  ABOUT_US_NAVIGATION_ITEM,
  HELP_NAVIGATION_ITEM,
  PRODUCTS_NAVIGATION_ITEM,
] as const

export const SMART_PAY_AS_YOU_GO_NAVIGATION = {
  TOP,
  SIDEBAR,
  TABLET,
  MOBILE,
} as const
